module.exports = __webpack_public_path__ + "media/images/lb/016-0083d1974eb75aac73bf9c630dc48d72.svg";